import React from 'react'
import { Order } from '../../../components/Order'
import { singleOrderQuery } from '../../../hooks/useOrder/graphql'
import { PayBalanceButton } from '../../../components/PayBalanceButton'
import { PageTitle } from '../../../components/PageTitle'
import { useContext } from '../Context'
import { InvoiceCheckoutButton } from '../InvoiceCheckoutButton'

export const Layout = () => {
  const { filter, orderComponents, order, accessToken } = useContext()
  const orderNumber = order?.code || ''
  const orderStatus = order?.status || 'in progress'

  const components = {
    ...orderComponents,
    CheckoutButton: () => (
      <>
        <InvoiceCheckoutButton />
        <PayBalanceButton accessToken={accessToken} />
      </>
    ),
  }

  return (
    <>
      <PageTitle
        title={`Invoice #${orderNumber}`}
        description={`View details of your ${orderStatus} order #${orderNumber}`}
      />
      <Order
        filter={filter}
        query={singleOrderQuery}
        canCancel={false}
        canEdit={false}
        showChat={false}
        components={components}
      />
    </>
  )
}
